<template>
	<div>
		<Header></Header>
		<Nav></Nav>
		<div class="framework">
			<div class="frame">
				<div class="frame-left">
					<p class="frame-left-top">活动管理</p>
					<div class="frame-left-ss">
						<img class="left-ss" src="../../../assets/purchase/image/framework/ss.png" />
						<input placeholder="搜索活动名称" v-model="searchFrame" ref="searchFrame"  @click="searchFrames()"/>
					</div>
					<div class="addlist">
						<ul>
							<li @click="myOrder(index,item.id)"  v-for="(item,index) in frame_list" :key="index" class="my-order" :class="{active:isActive == index}" v-text="item.name"></li>
						</ul>
					</div>
				</div>
					
				
				<div class="frame-right">
					<div v-if="frame_list && frame_list.length">
						<div class="frame-right-top">
							<div class="right-top-txt">
								<div class="frame-personal" @click="myOrderup(0)" :class="{active:framePersonal == 0}">活动概况</div>
								<div class="frame-personal" @click="myOrderup(1)" :class="{active:framePersonal == 1}">消费记录</div>
								<div class="frame-personal" @click="myOrderup(2)" :class="{active:framePersonal == 2}">用户管理</div>
								<div class="frame-personal" @click="exportList()" v-show="framePersonal == 2">导出</div>
							</div>
							<div v-if="framePersonal == 1" class="order_inquiry ">
								<input type="text" placeholder="请输入订单号" v-model="searchorder" ref="searchorder">
								<div class="inquiry_btn" @click="searchor()">搜索</div>
							</div>
							<div v-if="framePersonal == 2" class="order_inquiry ">
								<input type="text" placeholder="请输入账户名" v-model="searchyhgl" ref="searchorder">
								<div class="inquiry_btn" @click="searchyhgled()">搜索</div>
							</div>
						</div>
						<div v-show="framePersonal == 0">
							<div class="frame-right-center of_integral">
								<!-- <div class="cumulative_use">
									<p>{{hdconter.all_pay_parice}}</p>
									<p>当前消费累计</p>
								</div> -->
								<div class="cumulative_use">
									<p>{{hdconter.user_num}}人</p>
									<p>活动人数</p>
								</div>
								<div class="cumulative_use">
									<p>{{hdconter.all_integral}}</p>
									<p>总消费</p>
								</div>
								<div class="cumulative_use" v-if="hdconter.status == 0">
									<p>{{hdconter.start_date}}</p>
									<p>活动开始</p>
								</div>
								<div class="cumulative_use" v-if="hdconter.status == 1">
									<p>{{count}}</p>
									<p>距离结束</p>
								</div>
								<div class="cumulative_use" v-if="hdconter.status == 2">
									<p>{{hdconter.end_date}}</p>
									<p>活动结束</p>
								</div>
							</div>
							<div class="frame-right-tab">
								<div  v-if="per_list && per_list.length">
									<table class="right-tab">
										<tr>
											<th width="180px">人员</th>
											<th width="225px">金额</th>
											<th width="275px">已消费</th>
										</tr>
										<tr v-for="(item,index) in per_list" :key="index">
											<td>{{item.name}}</td>
											<td>{{item.integral}}</td>
											<td>{{item.consume}}</td>
										</tr>
									</table>
								</div>
								<template v-else>
									<div class="zanwugoods" v-if="datatype">
										<img src="../../../assets/images/ttshop_zanwu.png" alt="">
										<p>暂无数据</p>
									</div>
								</template>
							</div>
						</div>
						<div v-show="framePersonal == 1">
							<div class="ttshop-myorderlist">
								<div v-if="record_list && record_list.length">
									<div class="ttshop-myordertitle clearfloat">
										<div class="clearfloat">
											<div class="ttshop-myordertext">
												<div class="ttshop-myordertexter clearfloat">
													<div>全部订单</div>
												</div>
											</div>
											<div class="ttshop-myorderdj">
												<p style="margin-left: -20px;">账户</p>
											</div>
											<div class="ttshop-myorderdj">
												<p>消费金额</p>
											</div>
											<div class="ttshop-myorderdjs">
												<p>订单状态</p>
											</div>
											<div class="ttshop-myorderzfje">
												<p>操作</p>
											</div>
										</div>
									</div>
									<div class="ttshop-myordercon" v-for="(item,index) in record_list" v-model="index">
										<div class="ttshop-myorderconed clearfloat">
											<div class="ttshop-myordercontitle clearfloat">
												<p>订单号：<span>{{item.order_no}}</span></p>
											</div>
											<div class=" clearfloat d-flex orderlist">
												<div class="listitem">
													<div class="ttshop-myorderconlist d-flex clearfloat" v-for="(items,idx) in item.goods_list" :key="idx">
														<div class="ttshop-myorderconleft clearfloat">
															<div class="ttshop-ordertext">
																<h5>{{items.name}}</h5>
															</div>
														</div>
														<div class="ttshop-myorderdj">
															<p><span>{{item.name}}</span></p>
														</div>
														<div class="ttshop-myorderdj ttshop-myorderdjer">
															<p><span>{{item.pay_price}}</span></p>
														</div>
														<div class="ttshop-shr">
															<div>
																<p class="ttshop-over" v-if="item.apply_delete == 1">已取消</p>
																<p class="ttshop-over ttshop-over-examine" v-if="item.is_send == 0 && item.apply_delete == 0">待发货</p>
																<p class="ttshop-over ttshop-over-examine" v-if="item.is_send == 1 && item.is_confirm == 0">待收货</p>
																<p class="ttshop-over ttshop-over-adopt" v-if="item.is_confirm == 1">已收货</p>
															</div>
														</div>
													</div>
												</div>
												<div class="ttshop-caozuos d-flex  align-items-center justify-content-center">
													<p class="ttshop-cztext" @click="orderDetails(index)">订单详情</p>
												</div>
											</div>
										</div>
									</div>
								</div>
								<template v-else>
									<div class="zanwugoods" v-if="datatype">
										<img src="../../../assets/images/ttshop_zanwu.png" alt="">
										<p>暂无消费记录</p>
									</div>
								</template>
							</div>
						</div>
						<div v-show="framePersonal == 2">
							<div class="yhgl">
								<div class="yhglup" v-if="yhgl_list && yhgl_list.length">
									<div class="yhgltitle clearfloat">
										<p>账户</p>
										<p>姓名</p>
										<p>已消费金额</p>
										<p>订单数量</p>
										<p>操作</p>
									</div>
									<div class="yhlist">
										<ul>
											<li class="clearfloat" v-for="(item,index) in yhgl_list" :key="index">
												<p>{{item.username}}</p>
												<p>{{item.name}}</p>
												<p>{{item.consume}}</p>
												<p>{{item.order_num}}</p>
												<p class="yhlast" @click="userorder(item.id)">查看订单</p>
											</li>
										</ul>
									</div>
								</div>
								<template v-else>
									<div class="zanwugoods" v-if="datatype">
										<img src="../../../assets/images/ttshop_zanwu.png" alt="">
										<p>暂无任何活动</p>
									</div>
								</template>
							</div>
						</div>
						<div class="goods-paging d-flex align-items-center justify-content-center">
							<el-pagination background @current-change="handleCurrentChange" :current-page.sync="currentPage1" :page-size="limit"
							 :hide-on-single-page='true' layout="prev, pager, next, total, jumper" :total="ttshop_znum"></el-pagination>
						</div>
					</div>
					<template v-else>
						<div class="zanwugoods" v-if="datatype">
							<img src="../../../assets/images/ttshop_zanwu.png" alt="">
							<p>暂无任何活动</p>
						</div>
					</template>
				</div>
			</div>
		</div>
		<Footer></Footer>
	</div>
</template>

<script>
	import Header from "@/components/purchase/header/header";
	import Nav from "@/components/purchase/nav/nav";
	import Footer from "@/components/purchase/footer/footer";
	import "./activities.css";
	import axios from 'axios';
	// axios.defaults.baseURL = '/college';
	export default {
		components: {
			Header,
			Nav,
			Footer,
		},
		data() {
			return {
				route_url: this.$route.params.route_url,
				framePersonal: '',
				isActive: '',
                start_time:0,
                count:'',
				frame_list: [],
				searchFrame:"",
				actid:'',
				datatype: false,
				hdconter:'',
				currentPage1: 1, //页数
				ttshop_znum: 0, //总商品数
				limit: 12, //每页条数
				page_count: '', //总页数
				per_list:[],//员工列表
				record_list:[],//消费记录列表
				searchorder:"",
				yhgl_list:[],//用户管理列表
				searchyhgl:"",
                
			}
		},
		created() {
			let that = this;
			document.onkeydown = function(e) {
				let key = window.event.keyCode;
				if (key === 13) {
					if (that.$refs.searchFrame.value) {
						that.searchFrames();
					}
				}
			};
			that.departmentapi();
		},
		watch: {
			$route(to, from) {
				//监听路由是否变化
				if (to.params.route_url != from.params.route_url) {
					this.route_url = to.params.route_url;
				}
			},
		},
        mounted(){
			this.Time();
        },
		methods: {
			downloadFile(blobData, fileName) {
				// 使用 FileSaver.js 或类似的库来处理下载
				// 这里使用 FileSaver.js 作为示例
				const blobUrl = window.URL.createObjectURL(new Blob([blobData],{ type: 'application/vnd.ms-excel;charset=utf-8' }));
				const link = document.createElement('a');
				link.href = blobUrl;
				// link.setAttribute('download', fileName);
				// document.body.appendChild(link);

				link.download = fileName
				link.click();
				// document.body.removeChild(link);
				

			},
			// 导出
			exportList(){
				// this.$api.exportData({
				// 	shop_type: 'qycg',
				// 	access_token: this.$store.state.qycg_user.access_token,
				// 	act_id: this.actid,
				// 	responseType: 'blob',
				// }).then((res) => {
				// 	// 创建一个blob对象，并提供MIME类型信息
				// 	// const blobData = res.data;
    			// 	// const fileName = 'example.pdf'; // 设置你想要的文件名
    			// 	// this.downloadFile(blobData, fileName);
				// 	const url = window.URL.createObjectURL(new Blob([res.data],{ type: 'application/vnd.ms-excel;charset=utf-8' }))
				// 	const link = document.createElement('a');
				// 	link.href = url
				// 	link.setAttribute('download','文件名')
				// 	document.body.appendChild(link)
				// 	link.click()
				// }).catch((err) => {
				// 	// console.log(err);
				// });
				axios({
					url:'/business/manage/export?store_id=1&_version=2.8.9&_platform=pc&pur_key='+this.$route.params.route_url+'&access_token='+this.$store.state.qycg_user.access_token+'&shop_type=qycg&act_id='+this.actid,
					method:'GET',
					responseType:'blob'
				}).then(res=>{
					const url = window.URL.createObjectURL(new Blob([res.data],{ type: 'application/vnd.ms-excel;charset=utf-8' }))
					const link = document.createElement('a');
					link.href = url
					link.setAttribute('download','用户信息')
					document.body.appendChild(link)
					link.click()
				})
			},
            countDown() {
				let times = new Date()/1000;
				let endtime = this.start_time - times;
				let d = parseInt(endtime / (24 * 60 * 60))
				d = d < 10 ? "0" + d : d
				let h = parseInt(endtime / (60 * 60) % 24);
				h = h < 10 ? "0" + h : h
				let m = parseInt(endtime / 60 % 60);
				m = m < 10 ? "0" + m : m
				let s = parseInt(endtime % 60);
				s = s < 10 ? "0" + s : s
				if(d>0){
					this.count = d + '天' + h + '时' + m + '分' + s + '秒'
				}else{
					this.count =  h + ':' + m + ':' + s 
				}
			},
        //定时器没过1秒参数减1myOrderu
			Time() {
				setInterval(() => {
					// this.start_time -= 1
					this.countDown()
				}, 1000)
			},
			myOrder(i,id) {
				if(this.isActive === i){
					return false;
				}
				this.framePersonal = 0;
				this.isActive = i;
				this.actid = id;
				this.hddelect();
				this.staffjf();
			},
			myOrderup(i) {
				if(this.framePersonal === i){
					return false;
				}
				this.framePersonal = i;
				if(i == 0){
					this.hddelect();
					this.staffjf();
				}else if(i == 1){
					this.record();
				}else if(i == 2){
					this.yhglist();
				}
			},
			departmentapi() {
				let keyword = this.searchFrame;
				this.$api.department({
					shop_type: 'qycg',
					access_token: this.$store.state.qycg_user.access_token,
					keyword: keyword,
				}).then((res) => {
					if (res.data && res.data.length) {
						this.frame_list = res.data;
						this.myOrder(0, res.data[0].id)
					}
				}).catch((err) => {
					// console.log(err);
				});
			},
			searchFrames() {
				this.departmentapi();
			},
			hddelect() {
				this.$api.addelect({
					shop_type: 'qycg',
					act_id: this.actid,
					access_token: this.$store.state.qycg_user.access_token,
				}).then((res) => {
					// console.log(res.data.end_time)
					if(res.code==0){
						this.hdconter = res.data;
						this.start_time = res.data.end_time;
					}else{
							this.$message({
            	message: res.msg,
            	type: 'warning'
          	})
					}
					
					
				}).catch((err) => {
					// console.log(err);
				});
			},
			staffjf(){
				this.datatype = false;
				this.$api.staffint({
					page: this.currentPage1,
					limit: this.limit,
					act_id: this.actid,
					shop_type: 'qycg',
					access_token: this.$store.state.qycg_user.access_token,
				}).then((res) => {
					if(res.code==0){
						this.per_list = res.data.list;
						this.ttshop_znum = Number(res.data.row_count);
						this.page_count = res.data.page_count;
						this.datatype = true;
					}else{
						this.$message({
            	message: res.msg,
            	type: 'warning'
          	})
					}
					
					
				}).catch((err) => {
					// console.log(err);
				});
			},
			
			record(){
				let keyword = this.searchorder;
				this.datatype = false;
				this.$api.xfrecord({
					page: this.currentPage1,
					limit: this.limit,
					act_id: this.actid,
					keyword: keyword,
					shop_type: 'qycg',
					access_token: this.$store.state.qycg_user.access_token,
				}).then((res) => {
					this.record_list = res.data.list;
					this.ttshop_znum = Number(res.data.row_count);
					this.page_count = res.data.page_count;
					this.datatype = true;
					
				}).catch((err) => {
					// console.log(err);
				});
			},
			searchor(){
				if(this.searchorder == ''){
					this.$message({
						showClose: true,
						message: '订单号不可为空',
						type: 'warning',
						offset: 200,
						duration: 1000
					});
					return false;
				}
				this.record();
			},
			yhglist(){
				let keyword = this.searchyhgl;
				this.datatype = false;
				this.$api.yhgllist({
					page: this.currentPage1,
					limit: this.limit,
					act_id: this.actid,
					keyword: keyword,
					shop_type: 'qycg',
					access_token: this.$store.state.qycg_user.access_token,
				}).then((res) => {
					this.yhgl_list = res.data.list;
					this.ttshop_znum = Number(res.data.row_count);
					this.page_count = res.data.page_count;
					this.datatype = true;
					
				}).catch((err) => {
					// console.log(err);
				});
			},
			searchyhgled(){
				if(this.searchyhgl == ''){
					this.$message({
						showClose: true,
						message: '账户名不可为空',
						type: 'warning',
						offset: 200,
						duration: 1000
					});
					return false;
				}
				this.yhglist();
			},
			// 输入分页
			handleCurrentChange(e) {
				this.currentPage1 = e;
				if(this.framePersonal == 0){
					this.staffjf();
				}else if(this.framePersonal == 1){
					this.record();
				}else if(this.framePersonal == 2){
					this.yhglist();
				}
			},
			//订单详情
			orderDetails(index){
				let orderId = this.record_list[index].id;
				this.$router.push(this.common.qycgrouter(this) + "/userorderdetails");
				this.$store.commit("orderDetailsId", orderId);
			},
			userorder(userid){
				this.$router.push({
					path : this.common.qycgrouter(this) + "/userlist",
					query : {id:userid,ackid:this.actid}
				});
			}
		},
	}
</script>

<style lang="scss" scoped>
	.yhgl{
		width: 100%;
		.yhglup{
			width: 100%;
			padding: 20px;
			box-sizing: border-box;
			.yhgltitle{
				width: 100%;
				height: 32px;
				background: #f5f5f5;
				line-height: 32px;
				p{
					font-size: 12px;
					color: #333;
					float: left;
					width: 20%;
					text-align: center;
				}
			}
			.yhlist{
				width: 100%;
				ul{
					li{
						width: 100%;
						height: 40px;
						line-height: 40px;
						p{
							font-size: 12px;
							color: #333;
							float: left;
							width: 20%;
							text-align: center;
						}
						.yhlast{
							cursor: pointer;
							transition: 0.5s;
							-moz-transition: 0.5s;
							-webkit-transition: 0.5s;
							-o-transition: 0.5s;
							&:hover {
								color: #ff0e25;
							}
						}
						&:nth-child(2n){background: #f5f5f5;}
					}
				}
			}
		}
	}
	.ttshop-myorderzw {
		width: 100%;
		min-height: 600px;
		background: #fff;
		padding-top: 180px;
		box-sizing: border-box;
	
		// display: none;
		img {
			display: block;
			width: 93px;
			height: 80px;
			margin: 0 auto 20px;
		}
	
		p {
			font-size: 14px;
			color: #333;
			text-align: center;
		}
	}
	.zanwugoods {
		width: 100%;
		padding: 150px 0;
		box-sizing: border-box;
	
		img {
			display: block;
			width: 93px;
			height: 80px;
			margin: 0 auto 20px;
		}
	
		p {
			font-size: 16px;
			color: #333;
			text-align: center;
		}
	}
	
	.ttshop-myorderlist {
		width: 100%;
		padding: 20px;
		box-sizing: border-box;
		.ttshop-myordertitle {
			width: 100%;
			background: #f5f5f5;
			height: 32px;
			margin-bottom: 20px;
	
			.ttshop-myordertext {
				float: left;
				width: 362px;
				padding-top: 8px;
				padding-left: 20px;
				box-sizing: border-box;
	
				.ttshop-myordertexter {
					display: table;
					// cursor: pointer;
					width: 297px;
					position: relative;
					div{
						display: flex;
						align-items: center;
						img{
							width: 12px;
							height: 12px;
						}
					}
	
					// p {
					// 	float: left;
					// 	font-size: 12px;
					// 	color: #333;
					// }
					select {
						font-size: 12px;
						border: none;
						outline: none;
						color: #999999;
						background: #F5F5F5;
						cursor: pointer;
	
						option {
							color: #999999;
							outline: none;
							text-indent: 12px;
						}
					}
	
					i {
						float: left;
						width: 12px;
						height: 12px;
						margin-top: 2px;
	
						img {
							display: block;
							width: 100%;
						}
					}
				}
			}
	
			.ttshop-myorderdj {
				float: left;
				width: 120px;
				padding-top: 8px;
				box-sizing: border-box;
	
				p {
					font-size: 12px;
					color: #333;
					text-align: center;
				}
			}
	
			.ttshop-myorderdjs {
				float: left;
				width: 100px;
				padding-top: 8px;
				box-sizing: border-box;
	
				p {
					font-size: 12px;
					color: #333;
					text-align: center;
				}
			}
	
			.ttshop-myorderzfje {
				float: left;
				width: 115px;
				padding-top: 8px;
				box-sizing: border-box;
	
				p {
					font-size: 12px;
					color: #333;
					text-align: center;
				}
			}
	
			// .ttshop_myorderzt {
			//   float: left;
			//   width: 14%;
			//   padding-top: 8px;
			//   box-sizing: border-box;
			//   .ttshop_myorderzts {
			//     // cursor: pointer;
			//     p {
			//       float: left;
			//       font-size: 12px;
			//       color: #333;
			//     }
			//     i {
			//       float: left;
			//       width: 12px;
			//       height: 12px;
			//       margin-top: 2px;
			//       img {
			//         display: block;
			//         width: 100%;
			//       }
			//     }
			//   }
			// }
			.ttshop-myordercz {
				float: right;
				width: 150px;
				padding-top: 8px;
				box-sizing: border-box;
	
				p {
					font-size: 12px;
					color: #333;
					text-align: center;
				}
			}
		}
	
		.ttshop-myordercon {
			width: 100%;
	
			.ttshop-myorderconed {
				width: 100%;
				margin-bottom: 20px;
	
				.ttshop-myordercontitle {
					width: 100%;
					height: 32px;
					background: #f5f5f5;
					padding: 0 20px;
					box-sizing: border-box;
					line-height: 32px;
	
					p {
						float: left;
						font-size: 12px;
						color: #999;
	
						span {
							font-size: 12px;
							color: #999;
						}
	
						strong {
							color: #333;
							font-weight: 500;
						}
					}
	
					& p:last-child {
						margin-right: 0;
						// float: right;
					}
	
					.ttshop-myordercontitle-right {
						float: right;
						line-height: 32px;
	
						.ttshop-cancel {
							font-size: 12px;
							color: #999;
							// margin-bottom: 2px;
						}
	
						.ttshop-over {
							font-size: 12px;
							color: #ff0e25;
							margin-right: 24px; 
							// margin-bottom: 2px;
						}
						.ttshop-over-adopt{
							color: green;
						}
						.ttshop-over-examine{
							color: #FF9010;
						}
	
						strong {
							font-size: 12px;
							color: #ff0e25;
							font-weight: 400;
							cursor: pointer;
						}
					}
				}
	
				.ttshop-myorderconlist {
					width: 696px;
					border-left: 1px solid #ebebeb;
					border-bottom: 1px solid #ebebeb;
					box-sizing: border-box;
					border-right: 0;
					border-top: 0;
	
					.ttshop-myorderconleft {
						float: left;
						width: 50%;
						padding: 16px 20px 16px 10px;
						box-sizing: border-box;
	
						.ttshop-orderimg {
							float: left;
							width: 80px;
							height: 80px;
							margin-right: 12px;
	
							img {
								display: block;
								width: 100%;
								height: 100%;
								object-fit: cover;
							}
						}
	
						.ttshop-ordertext {
							width: 100%;
	
							h5 {
								font-size: 12px;
								color: #333333;
								font-weight: 500;
								line-height: 18px;
								display: -webkit-box;
								-webkit-box-orient: vertical;
								-webkit-line-clamp: 2;
								overflow: hidden;
								margin-bottom: 8px;
							}
	
							span {
								font-size: 12px;
								color: #999;
								margin-right: 5px;
	
								strong {
									font-weight: 400;
									font-size: 12px;
									color: #999;
								}
							}
						}
					}
	
					.ttshop-myorderdj {
						float: left;
						width: 19%;
						text-align: center;
						padding-top: 16px;
						box-sizing: border-box;
	
						p {
							font-size: 12px;
							color: #333;
	
							span {
								font-size: 12px;
								color: #333;
							}
						}
					}
	
					.ttshop-myorderdjer {
						border-right: 1px solid #ebebeb;
					}
	
					.ttshop-shr {
						float: left;
						width: 12%;
						text-align: center;
						padding-top: 16px;
						box-sizing: border-box;
						border-right: 1px solid #ebebeb;
	
						p {
							font-size: 12px;
							color: #333;
						}
					}
	
					.ttshop-zfzje {
						float: left;
						width: 16%;
						text-align: center;
						padding-top: 16px;
						min-height: 112px;
						box-sizing: border-box;
						border-right: 1px solid #ebebeb;
	
						p {
							font-size: 12px;
							color: #333;
							margin-bottom: 8px;
	
							span {
								font-size: 12px;
								color: #333;
							}
						}
	
						strong {
							font-size: 12px;
							color: #333;
							font-weight: 400;
							cursor: pointer;
							transition: 0.5s;
							-moz-transition: 0.5s;
							-webkit-transition: 0.5s;
							-o-transition: 0.5s;
	
							&:hover {
								color: #ff0e25;
							}
						}
					}
	
					// .ttshop_qbzt {
					//   float: left;
					//   width: 15%;
					//   text-align: center;
					//   padding-top: 16px;
					//   min-height: 138px;
					//   box-sizing: border-box;
					//   border-right: 1px solid #ebebeb;
					//   .ttshop_wfk {
					//     font-size: 12px;
					//     color: #ff8500;
					//     margin-bottom: 2px;
					//   }
					//   .ttshop_cancel {
					//     font-size: 12px;
					//     color: #999;
					//     margin-bottom: 2px;
					//   }
					//   .ttshop_over {
					//     font-size: 12px;
					//     color: #333;
					//     margin-bottom: 2px;
					//   }
					//   strong {
					//     font-size: 12px;
					//     color: #ff0e25;
					//     font-weight: 400;
					//     cursor: pointer;
					//   }
					// }
	
					.ttshop-caozuo {
						float: left;
						width: 16%;
						text-align: center;
						padding-top: 16px;
						min-height: 112px;
						box-sizing: border-box;
						border-right: 1px solid #ebebeb;
	
						.ttshop-ljzf {
							display: block;
							width: 72px;
							height: 24px;
							border: 1px solid #ff3346;
							background: #fff0f1;
							line-height: 24px;
							text-align: center;
							font-size: 12px;
							color: #ff0e25;
							margin: 0 auto 8px;
							border-radius: 2px;
							cursor: pointer;
						}
	
						.ttshop-cztext {
							font-size: 12px;
							color: #333;
							margin-bottom: 8px;
							cursor: pointer;
							transition: 0.5s;
							-moz-transition: 0.5s;
							-webkit-transition: 0.5s;
							-o-transition: 0.5s;
	
							&:hover {
								color: #ff0e25;
							}
						}
	
						.ttshop-hg {
							display: block;
							width: 72px;
							height: 24px;
							background: #ebebeb;
							line-height: 24px;
							text-align: center;
							font-size: 12px;
							color: #999;
							margin: 0 auto 8px;
							border-radius: 2px;
							cursor: pointer;
							transition: 0.5s;
							-moz-transition: 0.5s;
							-webkit-transition: 0.5s;
							-o-transition: 0.5s;
	
							&:hover {
								background: #ff0e25;
								color: #fff;
							}
						}
	
						.ttshop-queren {
							display: block;
							width: 72px;
							height: 24px;
							background: #ff0e25;
							line-height: 24px;
							text-align: center;
							font-size: 12px;
							color: #fff;
							margin: 0 auto 8px;
							border-radius: 2px;
							cursor: pointer;
						}
					}
				}
			}
	
			.ttshop-caozuos {
				float: right;
				width: 24%;
				text-align: center;
				box-sizing: border-box;
				border-right: 1px solid #ebebeb;
				border-bottom: 1px solid #ebebeb;
	
				.ttshop-agree {
					width: 72px;
					height: 24px;
					line-height: 24px;
					background: rgba($color: #3FD44C, $alpha: 0.3);
					border-radius: 2px;
					border: 1px solid #3FD44C;
					font-size: 12px;
					font-family: PingFangSC-Regular, PingFang SC;
					font-weight: 400;
					color: #17CD27;
					margin-bottom: 8px;
					cursor: pointer;
				}
	
				.ttshop-refuse {
					width: 72px;
					height: 24px;
					line-height: 24px;
					background: rgba($color: #FF3346, $alpha: 0.3);
					border-radius: 2px;
					border: 1px solid #FF3346;
					font-size: 12px;
					font-family: PingFangSC-Regular, PingFang SC;
					font-weight: 400;
					color: #FF3346;
					margin-bottom: 8px;
					cursor: pointer;
				}
	
	
				.ttshop-cztexts {
					font-size: 12px;
					color: #ff0e25;
					margin-bottom: 8px;
				}
	
				.ttshop-ljzf {
					display: block;
					width: 72px;
					height: 24px;
					border: 1px solid #ff3346;
					background: #fff0f1;
					line-height: 24px;
					text-align: center;
					font-size: 12px;
					color: #ff0e25;
					margin: 0 auto 8px;
					border-radius: 2px;
					cursor: pointer;
				}
	
				.ttshop-cztext {
					font-size: 12px;
					color: #333;
					margin-bottom: 8px;
					cursor: pointer;
					transition: 0.5s;
					-moz-transition: 0.5s;
					-webkit-transition: 0.5s;
					-o-transition: 0.5s;
	
					&:hover {
						color: #ff0e25;
					}
				}
	
				.ttshop-hg {
					display: block;
					width: 72px;
					height: 24px;
					background: #ebebeb;
					line-height: 24px;
					text-align: center;
					font-size: 12px;
					color: #999;
					margin: 0 auto 8px;
					border-radius: 2px;
					cursor: pointer;
					transition: 0.5s;
					-moz-transition: 0.5s;
					-webkit-transition: 0.5s;
					-o-transition: 0.5s;
	
					&:hover {
						background: #ff0e25;
						color: #fff;
					}
				}
	
				.ttshop-queren {
					display: block;
					width: 72px;
					height: 24px;
					background: #ff0e25;
					line-height: 24px;
					text-align: center;
					font-size: 12px;
					color: #fff;
					margin: 0 auto 8px;
					border-radius: 2px;
					cursor: pointer;
				}
			}
		}
	
		.ttshop-myorderpage {
			width: 100%;
			margin-top: 32px;
	
			.ttshop-pages {
				float: right;
			}
		}
	}
	.framework {
		width: 100%;
		background: #F2F2F2;
		padding-top: 20px;

		.frame {
			margin: 0 auto;
			padding-top: 32px;
			width: 1080px;
            // width: 65%;
			min-height: 740px;
			background: #FFFFFF;
			display: flex;

			.frame-left {
				// width: 255px;
                width: 20.5%;
				margin-top: -32px;
				font-size: 14px;
				height: 733px;

				.frame-left-top {
					width: 48px;
					height: 12px;
					font-size: 12px;
					margin-top: 20px;
					margin-left: 16px;
					font-family: PingFangSC-Regular, PingFang SC;
					font-weight: 400;
					color: #999999;
					line-height: 12px;
				}

				.frame-left-ss {
					margin-left: 16px;
					margin-top: 14px;
					width: 182px;
					height: 32px;
					background: #FFFFFF;
					border: 1px solid #F5F5F5;
					display: flex;

					.left-ss {
						width: 16px;
						height: 16px;
						margin: 8px 4px 0 8px;
					}

					.left-tj {
						width: 20px;
						height: 20px;
						margin: auto;
						margin-right: -39px;
						cursor: pointer;
					}
				}

				.zz {
					width: 14px;
					height: 14px;
					float: right;
					position: relative;
					top: 17px;
					left: 30px;
				}

				.grouping {
					height: 40px;
					color: #333333;
					margin-top: -20px;
					margin-left: -40px;
				}

				.el-personal {
					box-sizing: border-box;
					color: #333333;
					border-left: 2px solid transparent;
					width: 255px;
					height: 40px;
					margin-top: 12px;
					font-size: 14px;
					line-height: 40px;
					text-align: center;
					position: relative;
					cursor: pointer;

					i {
						font-size: 14px;
					}

					.zz {
						width: 14px;
						height: 14px;
						float: right;
						position: relative;
						top: 17px;
						left: -20px;
					}

					.box {
						width: 104px;
						height: 64px;
						position: absolute;
						right: 12px;
						top: 35px;
						box-shadow: 0px 0px 32px 0px rgba(0, 0, 0, 0.2);
						z-index: 100;
						display: none;
						background: #FFFFFF;

						.edit {
							width: 104px;
							height: 32px;
							line-height: 32px;
							text-align: center;
						}
					}

					.disbox {
						display: block;
					}
				}

				
			}

			.frame-right {
				// width: 825px;
                flex: 1;
				min-height: 733px;
				box-sizing: border-box;
				border-left: 1px solid #F5F5F5;
				margin-top: -32px;

				.frame-right-top {
					display: flex;
					min-height: 46px;
					_height: 46px;
					justify-content: space-between;

					.right-top-txt {
						font-family: PingFangSC-Regular, PingFang SC;
						font-weight: 400;
						color: #333333;
						margin-top: 20px;
						margin-left: 24px;
						display: flex;

						.frame-personal {
							width: 100px;
							height: 30px;
							font-size: 16px;
							border-radius: 15px;
							border: 1px black solid;
							text-align: center;
							line-height: 30px;
							margin-right: 12px;
							cursor: pointer;
						}

						.active {
							border: 1px red solid;
							color: red;
						}
					}
				}

				.frame-right-center {
                    width: 87%;
					height: 106px;
					background: #F5F5F5;
					border-radius: 4px;
					margin: 16px auto 0;
					display: flex;

					.right-center-funds {
						height: 60px;
						text-align: center;
						margin-top: 23px;
						text-indent: 24px;

						p {
							font-size: 12px;
							font-family: PingFangSC-Regular, PingFang SC;
							font-weight: 400;
							color: #333333;
							line-height: 12px;
							margin-bottom: 3px;

							span {
								height: 45px;
								font-size: 32px;
								font-weight: 600;
								line-height: 45px;
							}
						}
					}

					.right-center-funds-one {
						border-right: 1px solid #D8D8D8;
						padding-right: 12px;
					}
				}

				.frame-right-tab {
					// width: 777px;
                    width: 95%;
					margin: 10px auto 0;

					.right-tab {
                        width: 100%;
						border-collapse: collapse;

						tr {
							height: 40px;

							th {
								text-align: left;
							}

							th:first-child {
								text-indent: 16px;
							}

							td:first-child {
								text-indent: 16px;

								span {
									display: inline-block;
									border: 1px solid red;
									text-indent: 0px;
									background: rgba($color: pink, $alpha: 0.6);
									margin-left: 6px;
									border-radius: 3px;
								}
							}
						}

						tr:nth-child(odd) {
							/*奇数行*/
							background: #FAFAFA;
						}

						.operation {
							span {
								width: 24px;
								height: 12px;
								font-size: 12px;
								font-family: PingFangSC-Regular, PingFang SC;
								font-weight: 400;
								color: #3AB2F1;
								line-height: 12px;
								margin-right: 16px;
								cursor: pointer;
							}
						}
					}
				}
			}
		}
	}
	
	.addlist{
		width: 100%;
		margin-top: 10px;
		ul{
			li{
				width: 100%;
				height: 40px;
				font-size: 12px;
				border-radius: 0 4px 4px 0;
				text-align: center;
				color: #333;
				cursor: pointer;
				margin-bottom: 6px;
				line-height: 40px;
				&.active {
					border-left: 2px solid red;
					color: #FF3259;
					box-sizing: border-box;
					background: rgba(255, 0, 0, 0.1);
					i {
						color: red;
					}
				}
			}
		}
	}
    // 后续新增
    .of_integral{
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 4%;
        .cumulative_use{
            text-align: center;
            p:nth-child(1){
                font-size: 16px;
                font-weight: bold;
            }
            p:nth-child(2){
                font-size: 14px;
                margin-top: 5px;
            }
        }
    }
	.order_inquiry{
		display: flex;
		align-items: center;
		margin-top: 18px;
		margin-right: 24px;
		input{
			font-size: 14px;
			width: 180px;
			height: 32px;
			color: #333;
			padding: 0 10px;
			padding-left: 5px;
			border:solid 1px #ccc;
			border-right: 0;
			border-radius: 4px 0 0 4px;
			box-sizing: border-box;
		}
		.inquiry_btn{
			font-size: 14px;
			background: #3AB2F1;
			width: 52px;
			height: 32px;
			text-align: center;
			line-height: 32px;
			color: #fff;
			cursor: pointer;
			border-radius: 0 4px 4px 0;
		}
	}
	.new_class_style{
		width: 97% !important;
	}
</style>
